import React, { memo } from 'react'
import { ContractorRecollection, RecollectionType } from 'src/interfaces/contractor'
import { RecollectionBadge } from './RecollectionBadge'
import { CombinedRecollectionBadge } from './CombinedRecollectionBadge'

interface RecollectionIndicatorProps {
  recollections: ContractorRecollection[]
  muted?: boolean
}

const RecollectionIndicatorComponent = ({
  recollections,
  muted = false,
}: RecollectionIndicatorProps) => {
  if (!recollections?.length) {
    return null
  }

  const manualRecollection = recollections.find((item) => {
    return item.type === RecollectionType.Manual
  })
  const automaticRecollection = recollections.find((item) => {
    return item.type === RecollectionType.Automatic
  })

  if (manualRecollection && automaticRecollection) {
    return (
      <CombinedRecollectionBadge
        manualRecollection={manualRecollection}
        automaticRecollection={automaticRecollection}
        muted={muted}
      />
    )
  }

  return <RecollectionBadge recollection={recollections[0]} muted={muted} />
}

export const RecollectionIndicator = memo(RecollectionIndicatorComponent)
